import React from 'react';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Button } from '@bringg/react-components';

interface UndoButtonTranslation {
	undoLastChange: string;
}
interface Props {
	onUndoLastChange: () => void;
	isThereChange: boolean;
	translation: UndoButtonTranslation;
}
const UndoButton = (props: Props) => {
	const { onUndoLastChange, isThereChange, translation } = props;

	return (
		<Button
			size="small"
			type="link"
			className="undo-button"
			onClick={onUndoLastChange}
			disabled={!isThereChange}
			icon={<BringgIcon iconName={BringgFontIcons.Undo} className="undo-icon" />}
		>
			{translation.undoLastChange}
		</Button>
	);
};

export default UndoButton;
